import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { RemoteAuthorityResolverError } from 'vscode/vscode/vs/platform/remote/common/remoteAuthorityResolver';
import { IRemoteAuthorityResolverService } from 'vscode/vscode/vs/platform/remote/common/remoteAuthorityResolver.service';
import { AbstractRemoteAgentService } from '../common/abstractRemoteAgentService.js';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { ISignService } from 'vscode/vscode/vs/platform/sign/common/sign.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import 'vscode/vscode/vs/platform/notification/common/notification';
import { IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { IUserDataProfileService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/userDataProfile.service';
import { IRemoteSocketFactoryService } from 'vscode/vscode/vs/platform/remote/common/remoteSocketFactoryService.service';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

const _moduleId = "vs/workbench/services/remote/browser/remoteAgentService";
let RemoteAgentService = class RemoteAgentService extends AbstractRemoteAgentService {
    constructor(remoteSocketFactoryService, userDataProfileService, environmentService, productService, remoteAuthorityResolverService, signService, logService) {
        super(remoteSocketFactoryService, userDataProfileService, environmentService, productService, remoteAuthorityResolverService, signService, logService);
    }
};
RemoteAgentService = ( (__decorate([
    ( (__param(0, IRemoteSocketFactoryService))),
    ( (__param(1, IUserDataProfileService))),
    ( (__param(2, IWorkbenchEnvironmentService))),
    ( (__param(3, IProductService))),
    ( (__param(4, IRemoteAuthorityResolverService))),
    ( (__param(5, ISignService))),
    ( (__param(6, ILogService)))
], RemoteAgentService)));
let RemoteConnectionFailureNotificationContribution = class RemoteConnectionFailureNotificationContribution {
    static { this.ID = 'workbench.contrib.browserRemoteConnectionFailureNotification'; }
    constructor(remoteAgentService, _dialogService, _hostService) {
        this._dialogService = _dialogService;
        this._hostService = _hostService;
        remoteAgentService.getRawEnvironment()
            .then(undefined, (err) => {
            if (!RemoteAuthorityResolverError.isHandled(err)) {
                this._presentConnectionError(err);
            }
        });
    }
    async _presentConnectionError(err) {
        await this._dialogService.prompt({
            type: Severity$1.Error,
            message: ( localizeWithPath(
                _moduleId,
                0,
                "An unexpected error occurred that requires a reload of this page."
            )),
            detail: ( localizeWithPath(
                _moduleId,
                1,
                "The workbench failed to connect to the server (Error: {0})",
                err ? err.message : ''
            )),
            buttons: [
                {
                    label: ( localizeWithPath(_moduleId, 2, "&&Reload")),
                    run: () => this._hostService.reload()
                }
            ]
        });
    }
};
RemoteConnectionFailureNotificationContribution = ( (__decorate([
    ( (__param(0, IRemoteAgentService))),
    ( (__param(1, IDialogService))),
    ( (__param(2, IHostService)))
], RemoteConnectionFailureNotificationContribution)));
registerWorkbenchContribution2(RemoteConnectionFailureNotificationContribution.ID, RemoteConnectionFailureNotificationContribution, 2 );

export { RemoteAgentService };
